var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulk-purchase text-normal"},[_c('hero-section',{on:{"registerScrollRefs":_vm.registerScrollableRefs}}),_vm._v(" "),_c('media-reviews'),_vm._v(" "),_c('nzxt-bld-services',{on:{"scrollToRef":_vm.scrollToRef}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }